function selectVariant(event) {
    console.log("selectVariant called");
    var button = event.currentTarget;
    var cardWrapper = button.closest('.card-wrapper');
    var variantId = button.getAttribute('data-variant-id');
    var variantPrice = button.getAttribute('data-variant-price');
    var variantCompareAtPrice = button.getAttribute('data-variant-compare-at-price');
    var variantDiscount = button.getAttribute('data-variant-discount');
    var variantTitle = button.innerText;

    console.log("Variant selected:", {
        variantId, variantPrice, variantCompareAtPrice, variantDiscount, variantTitle
    });

    var imageLink = cardWrapper.querySelector('.card__inner a');
    var titleLink = cardWrapper.querySelector('.card__title a');
    var productHandle = cardWrapper.getAttribute('data-product-handle');
    var newUrl = `https://belenus.cl/products/${productHandle}?variant=${variantId}`;

    imageLink.setAttribute('href', newUrl);
    titleLink.setAttribute('href', newUrl);

    var priceElement = cardWrapper.querySelector('.current-price');
    var compareAtPriceElement = cardWrapper.querySelector('.compare-at-price');
    var addToCartButton = cardWrapper.querySelector('.add__cart button');
    var badgeElement = cardWrapper.querySelector('.card__badge .badge');

    priceElement.innerHTML = variantPrice;
    compareAtPriceElement.innerHTML = variantCompareAtPrice;
    compareAtPriceElement.style.display = variantCompareAtPrice ? 'inline' : 'none';

    if (/cliente\s*nuevo/i.test(variantTitle)) {
        addToCartButton.innerHTML = `Solicítalo aquí`;
        addToCartButton.setAttribute('onclick', `window.location.href='${newUrl}';`);
    } else {
        addToCartButton.innerHTML = `<svg style="font-size:21px;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><!--! Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc. --><path d="M0 24C0 10.7 10.7 0 24 0H69.5c22 0 41.5 12.8 50.6 32h411c26.3 0 45.5 25 38.6 50.4l-41 152.3c-8.5 31.4-37 53.3-69.5 53.3H170.7l5.4 28.5c2.2 11.3 12.1 19.5 23.6 19.5H488c13.3 0 24 10.7 24 24s-10.7 24-24 24H199.7c-34.6 0-64.3-24.6-70.7-58.5L77.4 54.5c-.7-3.8-4-6.5-7.9-6.5H24C10.7 48 0 37.3 0 24zM128 464a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm336-48a48 48 0 1 1 0 96 48 48 0 1 1 0-96zM252 160c0 11 9 20 20 20h44v44c0 11 9 20 20 20s20-9 20-20V180h44c11 0 20-9 20-20s-9-20-20-20H356V96c0-11-9-20-20-20s-20 9-20 20v44H272c-11 0-20 9-20 20z"/></svg> Agregar - ${variantPrice}`;
        addToCartButton.setAttribute('onclick', `handleAddToCartOrRequest('${variantId}', '${variantPrice}', '${productHandle}', '${variantTitle}');`);
    }

    if (variantDiscount > 0) {
        badgeElement.innerHTML = `-${variantDiscount}%`;
        badgeElement.style.display = 'none'; /* original inline */
    } else {
        badgeElement.style.display = 'none';
    }

    var buttons = cardWrapper.querySelectorAll('.variant-button');
    buttons.forEach(btn => btn.classList.remove('selected'));
    button.classList.add('selected');
}

function handleAddToCartOrRequest(variantId, variantPrice, productHandle, variantTitle) {
    console.log("handleAddToCartOrRequest called", { variantId, variantPrice, productHandle, variantTitle });
    if (/cliente\s*nuevo/i.test(variantTitle)) {
        window.location.href = `https://belenus.cl/products/${productHandle}?variant=${variantId}`;
    } else {
        addToCart(variantId);
    }
}

function addToCart(variantId) {
    console.log("addToCart called", { variantId });
    fetch('/cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        },
        body: JSON.stringify({
            items: [{
                id: variantId,
                quantity: 1
            }]
        })
    })
    .then(response => response.json())
    .then(data => {
        console.log('Producto añadido al carrito:', data);

        // Datos del producto para GA4
        const item = {
            item_id: variantId,
            item_name: data.title,
            price: data.price,
            quantity: 1,
        };

        // Enviar evento de comercio electrónico a GA4
        gtag('event', 'add_to_cart', {
            currency: 'USD',
            value: data.price,
            items: [item]
        });

        updateCartDrawer();
    })
    .catch((error) => {
        console.error('Error al añadir el producto al carrito:', error);
    });
}

function updateCartDrawer() {
    console.log("updateCartDrawer called");
    fetch('/?section_id=cart-drawer')
    .then(response => response.text())
    .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newDrawerContent = doc.querySelector('#CartDrawer .drawer__inner');
        const cartDrawerInner = document.querySelector('cart-drawer .drawer__inner');

        if (newDrawerContent && cartDrawerInner) {
            cartDrawerInner.innerHTML = newDrawerContent.innerHTML;
            document.querySelector('cart-drawer').open();
        }

        const newCartIconBubble = doc.querySelector('#cart-icon-bubble');
        const cartIconBubble = document.querySelector('#cart-icon-bubble');

        if (newCartIconBubble && cartIconBubble) {
            cartIconBubble.innerHTML = newCartIconBubble.innerHTML;
        }
    })
    .catch((error) => {
        console.error('Error al actualizar el carrito:', error);
    });
}

document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.variant-button').forEach(button => {
        console.log("Adding event listener to variant button:", button);
        button.addEventListener('click', selectVariant);
    });
});
